import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=d80e001a&scoped=true"
import script from "./JobView.vue?vue&type=script&setup=true&lang=js"
export * from "./JobView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobView.vue?vue&type=style&index=0&id=d80e001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80e001a",
  null
  
)

export default component.exports